import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { StyledCloseButton } from '../../../../styles/buttons';
import { StyledTitle } from '../../../../styles/text';
import { StyledModalHeader } from '../subcomponents';
var ModalHeader = function (_a) {
    var closeModal = _a.closeModal;
    var t = useTranslation().t;
    return (_jsxs(StyledModalHeader, { alignItems: "center", justifyContent: "space-between", children: [_jsx(StyledTitle, { id: "activity-modal-portal", children: t('activityDetails.activityDetailHeader') }), _jsx(StyledCloseButton, { className: "ensightencustomevent", "data-analytics": "clicktrackingevent", "data-object": "button", "data-reason": "close", "data-type": "close", onClick: closeModal, "aria-label": "close", children: _jsx(FontAwesomeIcon, { icon: faClose, size: "1x" }) })] }));
};
export default ModalHeader;
//# sourceMappingURL=index.js.map